import _ from '../../common/utility';

function committee () {
    if (!_.isCOE()) return;

    const $el = $(`<div class="show-details">
        <span>Show Details</span>
        <svg width="13" height="10" viewBox="0 0 13 10" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1l5.5 6.5 5-6.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
        </svg>
        </div>`);
    const $committee = $('#committee');

    $committee.after($el);

    $el.click(() => {
       $el.toggleClass('hide-details');
        $committee.toggleClass('show-intro');

        if($el.hasClass('hide-details')) {
            $el.find('span').text('Hide Details');
        } else {
            $el.find('span').text('Show Details');
        }
    })
}

export default _.catch(committee);